module.exports = __webpack_public_path__ + "static/media/e-comparison.12b80eab.png";